import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * State
 */
export type AuthSerialState = {
  // シリアル
  serial: string;
};

/**
 * 初期State
 */
const initialState: AuthSerialState = {
  serial: '',
};

/**
 * 認証シリアル Slice
 */
export const authSerialSlice = createSlice({
  name: 'authSerial',
  initialState,
  reducers: {
    // シリアルを更新
    setSerial: (state, action: PayloadAction<string>) => {
      state.serial = action.payload;
    },
    // リセット
    clearSerial: () => initialState,
  },
});
